import { useRef, useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Button,
  Container
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from 'components/Breadcrumbs';
import Iconify from 'components/Iconify';
import List from 'components/List2';
import InviteForm from 'sections/dialogs/InviteForm';
import { UserContext } from 'contexts';

import { getTeamMembers } from 'services/requests/user';
import { setMask } from 'utils';

export default function TeamInvited() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const listRef = useRef(null);
  const userContext = useContext(UserContext);

  const [isInviting, setIsInviting] = useState(false);

  const userRole = userContext?.state?.data?.role;
  const isCompanyActive = userRole === 'admin'
    ? userContext?.state?.data?.company?.active !== false
    : userContext?.state?.data?.provider?.active !== false;

  const handleNavigate = (row, e) => {
    if (e.target.tagName === 'A') return null
    e.preventDefault()
    navigate(`/equipe/perfil/${row.id}`)
  }

  const listConfig = {
    placeholderFilter: t('team.search'),
    onClick: (row, e) => handleNavigate(row, e),
    fields: [
      { key: 'name', label: t('team.listFields.name'), desktopColumnSize: 4, isPrimary: true },
      { key: 'email', label: t('team.listFields.email'), desktopColumnSize: 3 },
      {
        key: 'phone',
        label: t('team.listFields.phone'),
        desktopColumnSize: 3,
        customValue: row => (
          <>
            <a href={`https://wa.me/+55${row.phone}`} target="_blank">{setMask('(99) 99999-9999', row.phone)}</a>
            <Iconify icon="mingcute:whatsapp-fill" width={15} sx={{ ml: 1 }} />
          </>
        )
      },
      { key: 'role',
        label: t('team.listFields.role'),
        customValue: (row) => t(`profiles.${row.role}`),
        desktopColumnSize: 2
      },
    ]
  }

  return (
    <>
      <Helmet>
        <title> {t('team.pageTitle')} | { process.env.REACT_APP_PROJECT_NAME } </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Breadcrumbs
            items={[
              { label: t('team.title') }
            ]}
          />
          {isCompanyActive && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setIsInviting(true)}
              to="new"
            >
              {t('team.new')}
            </Button>
          )}
        </Stack>

        <List
          config={listConfig}
          getData={(params) => getTeamMembers({ ...params })}
          ref={listRef}
        />
      </Container>

      <InviteForm
        open={isInviting}
        onCancel={() => setIsInviting(false)}
      />
    </>
  )
}
